var _g, _rect, _rect2, _circle, _circle2, _circle3, _g2, _g3, _g4, _g5, _g6, _g7, _rect3, _g8, _g9, _g10, _g11, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 397,
    viewBox: "0 0 615 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_7732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 30,
    width: 529,
    height: 317,
    rx: 25,
    fill: "#21214C",
    fillOpacity: 0.02
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 30,
    width: 529,
    height: 317,
    rx: 25,
    fill: "url(#paint0_linear_1_7732)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 30.5,
    width: 528,
    height: 316,
    rx: 24.5,
    stroke: "#ACADAD",
    strokeOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 66.7088,
    cy: 52.7099,
    r: 6.7099,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 84.1545,
    cy: 52.7099,
    r: 6.7099,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 101.6,
    cy: 52.7099,
    r: 6.7099,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.9989,
    y: 80,
    width: 21,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9989,
    y: 112,
    width: 21,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9989,
    y: 144,
    width: 21,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9989,
    y: 176,
    width: 21,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9989,
    y: 208,
    width: 21,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9989,
    y: 240,
    width: 21,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9989,
    y: 272,
    width: 21,
    height: 14,
    rx: 7,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.9989,
    y: 80,
    width: 100,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297,
    y: 109,
    width: 205,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 80,
    width: 39,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 144,
    width: 43,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 144,
    width: 146,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.999,
    y: 109,
    width: 65,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.999,
    y: 109,
    width: 56,
    height: 14,
    rx: 7,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_d_1_7732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 226.999,
    y: 81,
    width: 133,
    height: 14,
    rx: 7,
    fill: "#F97A99"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.998,
    y: 208,
    width: 38,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.999,
    y: 240,
    width: 54,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.999,
    y: 240,
    width: 46,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.999,
    y: 288,
    width: 120,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.999,
    y: 240,
    width: 194,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.999,
    y: 208,
    width: 93,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.999,
    y: 208,
    width: 166,
    height: 14,
    rx: 7,
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_7732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.999,
    y: 203,
    width: 24,
    height: 24,
    rx: 8,
    fill: "url(#paint1_linear_1_7732)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.509 216.117C115.806 215.442 114.737 215.442 114.034 216.117C113.32 216.803 113.32 217.864 114.034 218.55L116.58 220.994C116.916 221.317 117.292 221.5 117.817 221.5C118.343 221.5 118.718 221.317 119.054 220.994L127.963 212.438C128.677 211.753 128.677 210.692 127.963 210.006C127.261 209.331 126.192 209.331 125.489 210.006L117.817 217.373L116.509 216.117Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1_7732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.9128,
    y: 175,
    width: 523.229,
    height: 126,
    rx: 5,
    fill: "url(#paint2_linear_1_7732)",
    fillOpacity: 0.2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 36,
    y: 175,
    width: 544,
    height: 84,
    rx: 5,
    fill: "url(#paint3_linear_1_7732)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1_7732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 175,
    width: 555,
    height: 11,
    rx: 3,
    fill: "url(#paint4_linear_1_7732)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1_7732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 72,
    width: 31,
    height: 31,
    rx: 8,
    fill: "url(#paint5_linear_1_7732)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.462 81.1966C226.462 79.6724 225.248 78.4583 223.724 78.4583C222.2 78.4583 220.985 79.6724 220.985 81.1966C220.985 83.4699 221.941 87.9649 222.768 90.6774H224.68C225.48 87.9649 226.462 83.4699 226.462 81.1966ZM226.333 94.3199C226.333 92.8733 225.145 91.6849 223.698 91.6849C222.2 91.6849 221.011 92.8733 221.011 94.3199C221.011 95.7924 222.2 97.0066 223.698 97.0066C225.145 97.0066 226.333 95.7924 226.333 94.3199Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1_7732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 278,
    width: 37,
    height: 37,
    rx: 8,
    fill: "url(#paint6_linear_1_7732)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.578 298.222C220.495 297.182 218.846 297.182 217.763 298.222C216.662 299.279 216.662 300.915 217.763 301.972L221.687 305.741C222.206 306.239 222.785 306.521 223.595 306.521C224.405 306.521 224.983 306.239 225.502 305.741L239.237 292.551C240.338 291.494 240.338 289.858 239.237 288.801C238.154 287.761 236.505 287.761 235.422 288.801L223.595 300.159L221.578 298.222ZM235.956 289.357L223.595 301.228L221.044 298.778C220.259 298.025 219.082 298.025 218.297 298.778C217.904 299.156 217.708 299.628 217.708 300.1C217.708 299.628 217.904 299.156 218.297 298.778C219.082 298.025 220.259 298.025 221.044 298.778L223.595 301.228L235.956 289.357C236.741 288.603 237.918 288.603 238.703 289.357C239.003 289.646 239.189 289.989 239.259 290.346C239.189 289.989 239.003 289.646 238.703 289.357C237.918 288.603 236.741 288.603 235.956 289.357Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1_7732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.43 246.935C310.37 248.368 307.637 248.368 305.577 246.935L259.574 214.937C257.961 213.816 257 211.976 257 210.012V132.917C257 130.4 258.567 128.169 260.992 127.491C268.217 125.471 284.981 121.682 309.07 121.682C333.145 121.682 349.829 125.467 357.021 127.488C359.439 128.167 361 130.394 361 132.907V210.012C361 211.976 360.039 213.816 358.426 214.937L312.43 246.935Z",
    fill: "url(#paint7_linear_1_7732)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.841 163.834C309.355 161.863 311.369 160.682 313.339 161.196C315.309 161.71 316.49 163.723 315.977 165.694L307.917 196.613C307.404 198.583 305.39 199.764 303.42 199.251C301.449 198.737 300.269 196.724 300.782 194.753L308.841 163.834ZM325.454 165.051C323.894 163.742 321.569 163.946 320.26 165.506C318.951 167.065 319.154 169.391 320.714 170.7L329.736 178.27L321.951 187.548C320.642 189.108 320.845 191.433 322.405 192.742C323.965 194.051 326.291 193.848 327.599 192.288L337.647 180.314C337.684 180.273 337.721 180.231 337.757 180.188C339.066 178.628 338.863 176.303 337.303 174.994L325.454 165.051ZM299.038 165.506C297.729 163.946 295.404 163.742 293.844 165.051L281.995 174.994C280.435 176.303 280.231 178.628 281.54 180.188C281.576 180.231 281.613 180.273 281.651 180.314L291.687 192.274C292.996 193.834 295.321 194.038 296.881 192.729C298.441 191.42 298.644 189.094 297.335 187.535L289.561 178.27L298.583 170.7C300.143 169.391 300.347 167.065 299.038 165.506Z",
    fill: "url(#paint8_linear_1_7732)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M432.221 266.651H433.063C435.307 246.274 453.259 230.304 474.577 230.304C481.87 230.304 488.883 232.231 495.054 235.536C503.189 219.29 520.019 208 539.934 208C567.424 208 589.583 229.753 589.583 256.738C589.583 260.593 589.022 264.173 588.461 267.752C603.609 271.056 614.829 284.549 614.829 300.244C614.829 318.693 599.401 333.837 580.607 333.837L574.997 333.562H438.112L432.221 333.837C413.428 333.837 398 318.968 398 300.244C398 281.52 413.428 266.651 432.221 266.651Z",
    fill: "url(#paint9_linear_1_7732)",
    fillOpacity: 0.02
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M432.221 266.651H433.063C435.307 246.274 453.259 230.304 474.577 230.304C481.87 230.304 488.883 232.231 495.054 235.536C503.189 219.29 520.019 208 539.934 208C567.424 208 589.583 229.753 589.583 256.738C589.583 260.593 589.022 264.173 588.461 267.752C603.609 271.056 614.829 284.549 614.829 300.244C614.829 318.693 599.401 333.837 580.607 333.837L574.997 333.562H438.112L432.221 333.837C413.428 333.837 398 318.968 398 300.244C398 281.52 413.428 266.651 432.221 266.651Z",
    fill: "url(#paint10_linear_1_7732)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M465.393 322.529H464.912C463.629 310.881 453.366 301.751 441.179 301.751C437.009 301.751 433 302.853 429.473 304.741C424.822 295.454 415.201 289 403.815 289C388.1 289 375.432 301.436 375.432 316.862C375.432 319.066 375.753 321.113 376.074 323.159C367.414 325.048 361 332.761 361 341.734C361 352.281 369.82 360.939 380.564 360.939L383.771 360.781H462.025L465.393 360.939C476.137 360.939 484.956 352.438 484.956 341.734C484.956 331.03 476.137 322.529 465.393 322.529Z",
    fill: "url(#paint11_linear_1_7732)",
    fillOpacity: 0.02
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M465.393 322.529H464.912C463.629 310.881 453.366 301.751 441.179 301.751C437.009 301.751 433 302.853 429.473 304.741C424.822 295.454 415.201 289 403.815 289C388.1 289 375.432 301.436 375.432 316.862C375.432 319.066 375.753 321.113 376.074 323.159C367.414 325.048 361 332.761 361 341.734C361 352.281 369.82 360.939 380.564 360.939L383.771 360.781H462.025L465.393 360.939C476.137 360.939 484.956 352.438 484.956 341.734C484.956 331.03 476.137 322.529 465.393 322.529Z",
    fill: "url(#paint12_linear_1_7732)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.206 312.105H133.587C131.938 297.129 118.744 285.392 103.077 285.392C97.7166 285.392 92.5627 286.809 88.0274 289.237C82.0489 277.297 69.6797 269 55.0429 269C34.8399 269 18.5538 284.987 18.5538 304.82C18.5538 307.653 18.9661 310.284 19.3784 312.914C8.24611 315.343 0 325.259 0 336.794C0 350.353 11.3384 361.483 25.1507 361.483L29.2737 361.281H129.876L134.206 361.483C148.018 361.483 159.356 350.555 159.356 336.794C159.356 323.033 148.018 312.105 134.206 312.105Z",
    fill: "url(#paint13_linear_1_7732)",
    fillOpacity: 0.02
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.206 312.105H133.587C131.938 297.129 118.744 285.392 103.077 285.392C97.7166 285.392 92.5627 286.809 88.0274 289.237C82.0489 277.297 69.6797 269 55.0429 269C34.8399 269 18.5538 284.987 18.5538 304.82C18.5538 307.653 18.9661 310.284 19.3784 312.914C8.24611 315.343 0 325.259 0 336.794C0 350.353 11.3384 361.483 25.1507 361.483L29.2737 361.281H129.876L134.206 361.483C148.018 361.483 159.356 350.555 159.356 336.794C159.356 323.033 148.018 312.105 134.206 312.105Z",
    fill: "url(#paint14_linear_1_7732)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_7732",
    x: 13,
    y: 20,
    width: 589,
    height: 377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_7732",
    x: 222.999,
    y: 81,
    width: 141,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.333333 0 0 0 0 0.468863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_7732",
    x: 104.999,
    y: 203,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1_7732",
    x: 3.91284,
    y: 135,
    width: 603.229,
    height: 206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_1_7732"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1_7732",
    x: 26,
    y: 173,
    width: 563,
    height: 19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1_7732",
    x: 204,
    y: 72,
    width: 39,
    height: 39,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1_7732",
    x: 206,
    y: 278,
    width: 45,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.298039 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1_7732",
    x: 243.059,
    y: 117.035,
    width: 131.882,
    height: 154.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.29412
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.97059
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.0823529 0 0 0 0 0.282353 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_7732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_7732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7732",
    x1: 80.9989,
    y1: 347,
    x2: 212.452,
    y2: 180.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#145DEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#441C99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_7732",
    x1: 108.999,
    y1: 203,
    x2: 137.234,
    y2: 210.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_7732",
    x1: 305.527,
    y1: 175,
    x2: 305.527,
    y2: 301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF78E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF78E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_7732",
    x1: 308,
    y1: 175,
    x2: 308,
    y2: 259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF78E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF78E1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_7732",
    x1: 30,
    y1: 167,
    x2: 31.4178,
    y2: 200.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF78E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9043C6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_7732",
    x1: 239,
    y1: 103,
    x2: 203.533,
    y2: 78.4557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E555AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F99048"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_7732",
    x1: 210,
    y1: 278,
    x2: 253.529,
    y2: 288.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#168982"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_7732",
    x1: 257,
    y1: 121.682,
    x2: 383.417,
    y2: 220.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9043C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A26B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_7732",
    x1: 289.042,
    y1: 161.076,
    x2: 352.256,
    y2: 188.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#145DEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_7732",
    x1: 571.105,
    y1: 205.715,
    x2: 449.597,
    y2: 389.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_7732",
    x1: 571.105,
    y1: 205.715,
    x2: 449.597,
    y2: 389.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_7732",
    x1: 385.996,
    y1: 287.693,
    x2: 455.46,
    y2: 392.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_7732",
    x1: 385.996,
    y1: 287.693,
    x2: 455.46,
    y2: 392.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_7732",
    x1: 32.1343,
    y1: 267.32,
    x2: 121.436,
    y2: 402.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_7732",
    x1: 32.1343,
    y1: 267.32,
    x2: 121.436,
    y2: 402.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.61469e-7,
    stopColor: "#D9DCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DCFA",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.520226bf772d4eac89d58ee6fefb9410.svg";
export { ForwardRef as ReactComponent };